<template>
    <div class="flex">
        <div class="hour-select" dusk="hour-select">
            <multiselect
                v-model="time.hour"
                @input="timeUpdated"
                :options="hourOptions"
                label="label"
                track-by="value"
                :searchable="false"
                :show-labels="false"
                :allow-empty="false"
                placeholder="Select">
            </multiselect>
        </div>

        <div class="seperator p-sm">:</div>

        <div class="minute-select" dusk="minute-select">
            <multiselect
                v-model="time.minute"
                @input="timeUpdated"
                :options="minuteOptions"
                label="label"
                track-by="value"
                :searchable="false"
                :show-labels="false"
                :allow-empty="false"
                placeholder="Select">
            </multiselect>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import Multiselect from 'vue-multiselect'
import HourOptions from '../options/hour-options'
import MinuteOptions from '../options/minute-options'

export default {
    props: {
        value: Object
    },
    data() {
        return {
            time: this.value
        }
    },
    computed: {
        hourOptions() {
            return HourOptions;
        },
        minuteOptions() {
            if (this.time.isMidnight()) {
                return _.take(MinuteOptions);
            }

            return MinuteOptions;
        }
    },
    watch: {
        value() {
            this.time = this.value;
        }
    },
    methods: {
        timeUpdated() {
            if (this.time.isMidnight()) {
                this.time.minute = MinuteOptions[0];
            }

            this.updateParent();
        },
         updateParent() {
            this.$emit('input', this.time);
        },
    },
    components: {
        Multiselect
    }
}
</script>

<style>
    .hour-select {
        width: 65%;
    }

    .minute-select {
        width: 30%;
    }

    .seperator {
        width: 5%;
    }
</style>
